<script setup>
const props = defineProps(['name', 'image', 'price', 'warning']);
const { t } = useI18n();
</script>

<template>
  <div class="club-card selected is-not-link">
    <div class="flex">
      <div>
        <img :src="image" :alt="name" class="club-card__image" />
      </div>
      <div class="mt-lg-0">
        <div class="club-card__header">
          <div class="club-card__title">
            <h3 class="heading heading--3 heading--upper">
              <span>{{ name }}</span>
            </h3>
          </div>
          <div class="club-card__price">
            <span class="heading heading--3 heading--thin">{{ t('pages.club.currency-year', [price]) }}</span>
          </div>
        </div>
        <div v-if="warning" class="club-card__warning">{{ warning }}</div>
        <div class="mt-2">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.club-card {
  display: block;
  padding: 20px;
  border: 1px solid transparent;

  @include mq($lg) {
    padding: 40px 55px;
  }

  &.is-link {
    cursor: pointer;

    &:hover {
      border-color: $black;

      .heading__link {
        background-size: 100% 2px;
      }
    }
  }

  &.is-selected {
    border-color: $black;
  }

  &__image {
    max-width: 416px;
    width: 100%;
  }

  &__header {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    margin-bottom: 8px;
  }

  &__title {
    margin-right: 15px;

    .heading {
      text-decoration: underline;

      @include mq($lg) {
        text-decoration: none;
      }
    }
  }

  &__price {
    margin-right: 15px;
  }

  &__warning {
    padding: 8px 10px;
    background: $sienna;
    color: $white;
    text-transform: uppercase;
    font-size: 10px;
    line-height: 1.2;
    display: inline-block;

    @include mq($lg) {
      margin-top: 0;
    }
  }
}

.flex {
  @media (min-width: 600px) {
    display: flex;
  }
}
.club-card__image {
  padding-bottom: 32px;
  @media (min-width: 600px) {
    width: 200px;
    padding-right: 32px;
  }
}

.club-card.is-not-link {
  cursor: default;
  border: 1px solid black;
}
</style>
